module Elma.Bindings {

    export class SubmitParentForm {

        public init(element: any, valueAccessor: () => any, allBindingsAccessor?: KnockoutAllBindingsAccessor) {
            // MAKE inputs limited to a certain number of chars
            // limitValue decides how many chars a user can submit
            element.onclick = function (e) {
                $(element).closest("form").submit(); 
            }
        }

    }

    ko.bindingHandlers['submitParentForm'] = new SubmitParentForm();

}